import { gql } from 'graphql.macro';
import { millingMaterialFragment } from 'apollo/fragments';

export const addMillingMaterialTemplate = gql`
    mutation addMillingMaterial($name: String!, $useVitaColors: Boolean!, $additionalColors: [String]!) {
        addMillingMaterial(name: $name, useVitaColors: $useVitaColors, additionalColors: $additionalColors) {
            ...millingMaterialFields
        }
    }
    ${millingMaterialFragment}
`;

export const modifyMillingMaterialTemplate = gql`
    mutation modifyMillingMaterial(
        $materialId: MongoDbObjectId
        $name: String
        $useVitaColors: Boolean
        $additionalColors: [String]
    ) {
        modifyMillingMaterial(
            materialId: $materialId
            name: $name
            useVitaColors: $useVitaColors
            additionalColors: $additionalColors
        ) {
            _id
        }
    }
`;

export const deleteMillingMaterialTemplate = gql`
    mutation deleteMillingMaterial($materialId: MongoDbObjectId!) {
        deleteMillingMaterial(materialId: $materialId)
    }
`;

export const addMillingJobTypeTemplate = gql`
    mutation addMillingJobType($name: String, $materials: [MongoDbObjectId]) {
        addMillingJobType(name: $name, materials: $materials) {
            _id
        }
    }
`;

export const modifyMillingJobTypeTemplate = gql`
    mutation modifyMillingJobType($jobTypeId: MongoDbObjectId, $name: String, $materials: [MongoDbObjectId]) {
        modifyMillingJobType(jobTypeId: $jobTypeId, name: $name, materials: $materials) {
            _id
        }
    }
`;

export const deleteMillingJobTypeTemplate = gql`
    mutation deleteMillingJobType($jobTypeId: MongoDbObjectId) {
        deleteMillingJobType(jobTypeId: $jobTypeId)
    }
`;

export const deleteMillingJobTemplate = gql`
    mutation deleteMillingJob($millingJobId: MongoDbObjectId!) {
        deleteMillingJob(millingJobId: $millingJobId)
    }
`;

export const addMillingBatchTemplate = gql`
    mutation addMillingBatch($millingJobIds: [MongoDbObjectId]!, $batchNumber: String) {
        addMillingBatch(millingJobIds: $millingJobIds, batchNumber: $batchNumber) {
            _id
        }
    }
`;

export const finishMillingBatchTemplate = gql`
    mutation finishMillingBatch($millingBatchId: MongoDbObjectId!) {
        finishMillingBatch(millingBatchId: $millingBatchId) {
            _id
            status
        }
    }
`;

export const deleteMillingBatchTemplate = gql`
    mutation deleteMillingBatch($millingBatchId: MongoDbObjectId!) {
        deleteMillingBatch(millingBatchId: $millingBatchId)
    }
`;

export const redoMillingJobTemplate = gql`
    mutation redoMillingJob($millingJobId: MongoDbObjectId!, $reason: MillingJobCopyReason!) {
        redoMillingJob(millingJobId: $millingJobId, reason: $reason) {
            _id
            copyReason
            status
        }
    }
`;
